<template>
  <RF-Dialog :id="cpntHashId"
    :cpntStatus='statusGeral'
    :cpntLargura='"500px"'
    :cpntOnFecharDialog='veiFormFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <template v-if="atualizando === true">
        Atualizando Placa
      </template>
      <template v-else>
        <!-- SETA O TITULO DA ABA -->
        <template v-if="cpntId === 0 || cpntId.length === 1 && cpntId[0] === 0">Novo Veículo</template>
        <template v-else-if="cpntId >= 1 || cpntId.length === 1 && cpntId[0] >= 1">
          <!-- SETA O TITULO DA ABA -->
          Edição do Veículo - {{ cpntId >= 1 ? cpntId : cpntId[0] }}

          <!-- SETA OS DADOS DO VEICULO EDITADO -->
          <div v-if="statusGeral === ''" style="padding-left: 15px;" v-html="veiFormTituloDialog"></div>
        </template>
        <template v-else-if="cpntId.length >= 2">Editar Varios</template>
      </template>
    </template>

    <template slot='conteudo'>
      <div style="text-align: center;" v-if="atualizando === true">
        <br/>
        <br/>
        Por favor aguarde...
        <br/>
        <br/>
        <br/>
        Estamos atualizado a placa deste veículo no sistema Rotina Fácil.
        <br/>
        <br/>
        <br/>
        <RF-Status :cpntStatus='"carregando"' :cpntIcone="true" :cpntFrase="false" :cpntTamanho='5'></RF-Status>
        <br/>
      </div>

      <div class="vei-form" v-else>
        <div>
          <App-Autocompletar :data-time="time" class="app-cpnt-field vei-form--id_con" :class="campos.id_con.class"
            :cpntStatus='campos.id_con.status'
            :cpntId='campos.id_con.id'
            :cpntTabIndex='campos.id_con.tabIndex'
            :cpntNome='campos.id_con.nome'
            :cpntValue='campos.id_con.value'
            :cpntMensagem='campos.id_con.mensagem'
            :cpntMensagemTipo='campos.id_con.mensagemTipo'
            :cpntDisabled='campos.id_con.disabled'
            :cpntMostrar='campos.id_con.mostrar'
            :cpntExplica='campos.id_con.explica'
            :cpntPlaceholder='campos.id_con.placeholder'
            :cpntValueRef='campos.id_con.valueRef'
            :cpntRouter='campos.id_con.router'
            :cpntMethod='campos.id_con.method'
            :cpntField='campos.id_con.field'
            :cpntWhere='campos.id_con.where'
            :cpntAddButForm='campos.id_con.addButForm'
            :cpntKeyMostra='campos.id_con.keyMostra'
            :cpntTipoOrder='campos.id_con.tipoOrder'
            :cpntOrder='campos.id_con.order'
            :cpntOptions='campos.id_con.options'
            :cpntKeyValue='campos.id_con.keyValue'
            :cpntSearchMinimo='campos.id_con.searchMinimo'
            :cpntMask='campos.id_con.mask'
            :cpntOptionInicialNome='campos.id_con.optionInicialNome'
            :cpntOptionInicialValue='campos.id_con.optionInicialValue'
            :cpntNewOption='campos.id_con.newOption'

            :cpntOnChange='campos.id_con.onChange'
            :cpntOnBlur='campos.id_con.onBlur'
            :cpntOnRealizaBusca='campos.id_con.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.id_con.onKeyPressEnter'
            ref="id_con"
          ></App-Autocompletar>

          <App-Input :data-time="time" class="app-cpnt-field vei-form--placa" :class="campos.placa.class"
            :cpntStatus='campos.placa.status'
            :cpntId='campos.placa.id'
            :cpntClassDivField='campos.placa.classDivField'
            :cpntNome='campos.placa.nome'
            :cpntValue='campos.placa.value'
            :cpntAutoComplete='campos.placa.autocomplete'
            :cpntMask='campos.placa.mask'
            :cpntOptionInicialNome='campos.placa.optionInicialNome'
            :cpntOptionInicialValue='campos.placa.optionInicialValue'
            :cpntDisabled='campos.placa.disabled'
            :cpntMostrar='campos.placa.mostrar()'
            :cpntAutoFocus='campos.placa.autofocus'
            :cpntMensagem='campos.placa.mensagem'
            :cpntMensagemTipo='campos.placa.mensagemTipo'
            :cpntPlaceholder='campos.placa.placeholder'
            :cpntPosicionar='campos.placa.posicionar'
            :cpntOnChange='campos.placa.onChange'
            :cpntOnBlur='campos.placa.onBlur'
            ref='placa'
          ></App-Input>

          <RF-Button :data-time="time" class="app-cpnt-field vei-form--buscar"
            :cpntId='campos.buscar.id'
            :cpntStatus='campos.buscar.status' 
            :cpntTipo='campos.buscar.tipo'
            :cpntTexto='campos.buscar.texto'
            :cpntIcone='campos.buscar.icone'
            :cpntTitle='campos.buscar.title'
            :cpntClass='campos.buscar.class'
            :cpntDisabled='campos.buscar.disabled'
            @onClickButton='campos.buscar.onClick'
          ></RF-Button>
        </div>

        <div>
          <App-Select :data-time="time" class="app-cpnt-field vei-form--marca" :class="campos.id_mar.class"
            :cpntStatus='campos.id_mar.status'
            :cpntId='campos.id_mar.id'
            :cpntTabIndex='campos.id_mar.tabIndex'
            :cpntNome='campos.id_mar.nome'
            :cpntValue='campos.id_mar.value'
            :cpntMensagem='campos.id_mar.mensagem'
            :cpntMensagemTipo='campos.id_mar.mensagemTipo'
            :cpntDisabled='campos.id_mar.disabled'
            :cpntMostrar='campos.id_mar.mostrar'
            :cpntExplica='campos.id_mar.explica'
            :cpntPlaceholder='campos.id_mar.placeholder'
            :cpntValueRef='campos.id_mar.valueRef'
            :cpntRouter='campos.id_mar.router'
            :cpntMethod='campos.id_mar.method'
            :cpntField='campos.id_mar.field'
            :cpntWhere='campos.id_mar.where'
            :cpntAddButForm='campos.id_mar.addButForm'
            :cpntKeyMostra='campos.id_mar.keyMostra'
            :cpntTipoOrder='campos.id_mar.tipoOrder'
            :cpntOrder='campos.id_mar.order'
            :cpntOptions='campos.id_mar.options'
            :cpntKeyValue='campos.id_mar.keyValue'
            :cpntSearchMinimo='campos.id_mar.searchMinimo'
            :cpntMask='campos.id_mar.mask'
            :cpntOptionInicialNome='campos.id_mar.optionInicialNome'
            :cpntOptionInicialValue='campos.id_mar.optionInicialValue'
            :cpntNewOption='campos.id_mar.newOption'
            
            :cpntOnBuscarOptions='campos.id_mar.onBuscarOptions'
            :cpntOnChange='campos.id_mar.onChange'
            :cpntOnBlur='campos.id_mar.onBlur'
            :cpntOnRealizaBusca='campos.id_mar.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.id_mar.onKeyPressEnter'
            ref="marca"
          ></App-Select>
          <App-Select :data-time="time" class="app-cpnt-field vei-form--modelo" :class="campos.id_mod.class"
            :cpntStatus='campos.id_mod.status'
            :cpntId='campos.id_mod.id'
            :cpntTabIndex='campos.id_mod.tabIndex'
            :cpntNome='campos.id_mod.nome'
            :cpntValue='campos.id_mod.value'
            :cpntMensagem='campos.id_mod.mensagem'
            :cpntMensagemTipo='campos.id_mod.mensagemTipo'
            :cpntDisabled='campos.id_mod.disabled'
            :cpntMostrar='campos.id_mod.mostrar'
            :cpntExplica='campos.id_mod.explica'
            :cpntPlaceholder='campos.id_mod.placeholder'
            :cpntValueRef='campos.id_mod.valueRef'
            :cpntRouter='campos.id_mod.router'
            :cpntMethod='campos.id_mod.method'
            :cpntField='campos.id_mod.field'
            :cpntWhere='campos.id_mod.where'
            :cpntAddButForm='campos.id_mod.addButForm'
            :cpntKeyMostra='campos.id_mod.keyMostra'
            :cpntTipoOrder='campos.id_mod.tipoOrder'
            :cpntOrder='campos.id_mod.order'
            :cpntOptions='campos.id_mod.options'
            :cpntKeyValue='campos.id_mod.keyValue'
            :cpntSearchMinimo='campos.id_mod.searchMinimo'
            :cpntMask='campos.id_mod.mask'
            :cpntOptionInicialNome='campos.id_mod.optionInicialNome'
            :cpntOptionInicialValue='campos.id_mod.optionInicialValue'
            :cpntNewOption='campos.id_mod.newOption'

            :cpntOnBuscarOptions='campos.id_mod.onBuscarOptions'
            :cpntOnChange='campos.id_mod.onChange'
            :cpntOnBlur='campos.id_mod.onBlur'
            :cpntOnRealizaBusca='campos.id_mod.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.id_mod.onKeyPressEnter'
            ref="modelo"
          ></App-Select>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field vei-form--ano" :class="campos.ano.class"
            :cpntStatus='campos.ano.status'
            :cpntId='campos.ano.id'
            :cpntClassDivField='campos.ano.classDivField'
            :cpntNome='campos.ano.nome'
            :cpntValue='campos.ano.value'
            :cpntAutoComplete='campos.ano.autocomplete'
            :cpntMask='campos.ano.mask'
            :cpntOptionInicialNome='campos.ano.optionInicialNome'
            :cpntOptionInicialValue='campos.ano.optionInicialValue'
            :cpntDisabled='campos.ano.disabled'
            :cpntMostrar='campos.ano.mostrar'
            :cpntAutoFocus='campos.ano.autofocus'
            :cpntMensagem='campos.ano.mensagem'
            :cpntMensagemTipo='campos.ano.mensagemTipo'
            :cpntPlaceholder='campos.ano.placeholder'
            :cpntPosicionar='campos.ano.posicionar'
            :cpntOnChange='campos.ano.onChange'
            :cpntOnBlur='campos.ano.onBlur'
            ref='ano'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field vei-form--cor" :class="campos.cor.class"
            :cpntStatus='campos.cor.status'
            :cpntId='campos.cor.id'
            :cpntClassDivField='campos.cor.classDivField'
            :cpntNome='campos.cor.nome'
            :cpntValue='campos.cor.value'
            :cpntAutoComplete='campos.cor.autocomplete'
            :cpntMask='campos.cor.mask'
            :cpntOptionInicialNome='campos.cor.optionInicialNome'
            :cpntOptionInicialValue='campos.cor.optionInicialValue'
            :cpntDisabled='campos.cor.disabled'
            :cpntMostrar='campos.cor.mostrar'
            :cpntAutoFocus='campos.cor.autofocus'
            :cpntMensagem='campos.cor.mensagem'
            :cpntMensagemTipo='campos.cor.mensagemTipo'
            :cpntPlaceholder='campos.cor.placeholder'
            :cpntPosicionar='campos.cor.posicionar'
            :cpntOnChange='campos.cor.onChange'
            :cpntOnBlur='campos.cor.onBlur'
            ref='cor'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field vei-form--motor" :class="campos.motor.class"
            :cpntStatus='campos.motor.status'
            :cpntId='campos.motor.id'
            :cpntClassDivField='campos.motor.classDivField'
            :cpntNome='campos.motor.nome'
            :cpntValue='campos.motor.value'
            :cpntAutoComplete='campos.motor.autocomplete'
            :cpntMask='campos.motor.mask'
            :cpntOptionInicialNome='campos.motor.optionInicialNome'
            :cpntOptionInicialValue='campos.motor.optionInicialValue'
            :cpntDisabled='campos.motor.disabled'
            :cpntMostrar='campos.motor.mostrar'
            :cpntAutoFocus='campos.motor.autofocus'
            :cpntMensagem='campos.motor.mensagem'
            :cpntMensagemTipo='campos.motor.mensagemTipo'
            :cpntPlaceholder='campos.motor.placeholder'
            :cpntPosicionar='campos.motor.posicionar'
            :cpntOnChange='campos.motor.onChange'
            :cpntOnBlur='campos.motor.onBlur'
            ref='motor'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field vei-form--combus" :class="campos.combus.class"
            :cpntStatus='campos.combus.status'
            :cpntId='campos.combus.id'
            :cpntClassDivField='campos.combus.classDivField'
            :cpntNome='campos.combus.nome'
            :cpntValue='campos.combus.value'
            :cpntAutoComplete='campos.combus.autocomplete'
            :cpntMask='campos.combus.mask'
            :cpntOptionInicialNome='campos.combus.optionInicialNome'
            :cpntOptionInicialValue='campos.combus.optionInicialValue'
            :cpntDisabled='campos.combus.disabled'
            :cpntMostrar='campos.combus.mostrar'
            :cpntAutoFocus='campos.combus.autofocus'
            :cpntMensagem='campos.combus.mensagem'
            :cpntMensagemTipo='campos.combus.mensagemTipo'
            :cpntPlaceholder='campos.combus.placeholder'
            :cpntPosicionar='campos.combus.posicionar'
            :cpntOnChange='campos.combus.onChange'
            :cpntOnBlur='campos.combus.onBlur'
            ref='combus'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field vei-form--km" :class="campos.km.class"
            :cpntStatus='campos.km.status'
            :cpntId='campos.km.id'
            :cpntClassDivField='campos.km.classDivField'
            :cpntNome='campos.km.nome'
            :cpntValue='campos.km.value'
            :cpntAutoComplete='campos.km.autocomplete'
            :cpntMask='campos.km.mask'
            :cpntOptionInicialNome='campos.km.optionInicialNome'
            :cpntOptionInicialValue='campos.km.optionInicialValue'
            :cpntDisabled='campos.km.disabled'
            :cpntMostrar='campos.km.mostrar'
            :cpntAutoFocus='campos.km.autofocus'
            :cpntMensagem='campos.km.mensagem'
            :cpntMensagemTipo='campos.km.mensagemTipo'
            :cpntPlaceholder='campos.km.placeholder'
            :cpntPosicionar='campos.km.posicionar'
            :cpntOnChange='campos.km.onChange'
            :cpntOnBlur='campos.km.onBlur'
            ref='km'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field vei-form--obs" :class="campos.obs.class"
            :cpntStatus='campos.obs.status'
            :cpntId='campos.obs.id'
            :cpntClassDivField='campos.obs.classDivField'
            :cpntNome='campos.obs.nome'
            :cpntValue='campos.obs.value'
            :cpntAutoComplete='campos.obs.autocomplete'
            :cpntMask='campos.obs.mask'
            :cpntOptionInicialNome='campos.obs.optionInicialNome'
            :cpntOptionInicialValue='campos.obs.optionInicialValue'
            :cpntDisabled='campos.obs.disabled'
            :cpntMostrar='campos.obs.mostrar'
            :cpntAutoFocus='campos.obs.autofocus'
            :cpntMensagem='campos.obs.mensagem'
            :cpntMensagemTipo='campos.obs.mensagemTipo'
            :cpntPlaceholder='campos.obs.placeholder'
            :cpntPosicionar='campos.obs.posicionar'
            :cpntOnChange='campos.obs.onChange'
            :cpntOnBlur='campos.obs.onBlur'
            ref='obs'
          ></App-Input>
        </div>
      </div>
    </template>

    <template slot='rodape' v-if="atualizando === false">
      <div class="vei-form-botoes">
        <RF-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClickButton='botoes.cancelar.onClick'
        ></RF-Button>

        <RF-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClickButton='botoes.salvar.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.vei-form {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .vei-form > div:not(:first-child) {
    padding-top: 22px;
  }
  .vei-form > div,
  .vei-form > div > div {
    width: 100%;
  }
    .vei-form > div > .vei-form--id_con {
      width: calc(65% - 10px);
      margin-right: 10px;
    }
    .vei-form > div > .vei-form--placa {
      width: calc(35% - 35px);
    }

    .vei-form > div > .vei-form--marca,
    .vei-form > div > .vei-form--modelo,
    .vei-form > div > .vei-form--ano,
    .vei-form > div > .vei-form--cor,
    .vei-form > div > .vei-form--motor,
    .vei-form > div > .vei-form--combus,
    .vei-form > div > .vei-form--km,
    .vei-form > div > .vei-form--obs {
      width: calc(50% - 5px);
    }
    .vei-form > div > .vei-form--marca,
    .vei-form > div > .vei-form--ano,
    .vei-form > div > .vei-form--motor,
    .vei-form > div > .vei-form--km {
      margin-right: 10px;
    }

  .vei-form-botoes {
    text-align: right;
  }
    .vei-form-botoes > button:not(:first-child) {
      margin-left: 5px;
    }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'vei-form-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntId: {
        required: false,
        default: function () {
          return 0
        }
      },
      cpntNomeDig: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        atualizando: false,
        campos: {
          id_con: {
            id: this.cpntHashId + '--id_con',
            status: '',
            nome: 'Proprietário',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo proprietário' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.veiFormOnNovoContato
            },
            mostrar: true,
            value: '',
            valueRef: '',
            apiEnv: 'id_con',
            onChange: this.veiFormOnChangeValue
          },
          placa: {
            id: this.cpntHashId + '--placa',
            status: '',
            nome: 'Placa',
            mostrar: () => { return this.veiFormMostrarPlaca },
            mask: 'placa',
            value: '',
            apiEnv: 'placa',
            onChange: this.veiFormOnChangeValue
          },
          buscar: {
            id: this.cpntHashId + '--buscar',
            status: '',
            tipo: 'icone',
            title: 'Buscar',
            icone: { tipo: 'busca-ws' },
            class: [ 'btn', 'btn-warning', 'btn-sm', 'cpnt-buscar-cadastro' ],
            onClick: () => { this.veiFormBuscarCadastroApi() }
          },
          id_mar: {
            id: this.cpntHashId + '--id_mar',
            status: '',
            nome: 'Marca',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            apiEnv: 'id_mar',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            onBuscarOptions: this.veiFormBuscarMarca,
            onChange: this.veiFormOnChangeValue
          },
          id_mod: {
            id: this.cpntHashId + '--id_mod',
            status: '',
            nome: 'Modelo',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            apiEnv: 'id_mod',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            newOption: true,
            onBuscarOptions: this.veiFormBuscarModelo,
            onChange: this.veiFormOnChangeValue
          },
          ano: {
            id: this.cpntHashId + '--ano',
            status: '',
            nome: 'Ano',
            mostrar: true,
            value: '',
            apiEnv: 'ano',
            explica: { mensagem: 'Informe o ano de fabricação e o ano do modelo do veículo.<br/><br/>Exemplo:<br/>15/16' },
            onChange: this.veiFormOnChangeValue
          },
          cor: {
            id: this.cpntHashId + '--cor',
            status: '',
            nome: 'Cor',
            mostrar: true,
            value: '',
            apiEnv: 'cor',
            onChange: this.veiFormOnChangeValue
          },
          motor: {
            id: this.cpntHashId + '--motor',
            status: '',
            nome: 'Motor',
            mostrar: true,
            value: '',
            apiEnv: 'motor',
            explica: { mensagem: 'Informe as especificações do motor deste veículo.<br/><br/>Exemplo:<br/>2.0 16V' },
            onChange: this.veiFormOnChangeValue
          },
          combus: {
            id: this.cpntHashId + '--combus',
            status: '',
            nome: 'Combustível',
            mostrar: true,
            value: '',
            apiEnv: 'combus',
            onChange: this.veiFormOnChangeValue
          },
          km: {
            id: this.cpntHashId + '--km',
            status: '',
            nome: 'KM',
            mostrar: true,
            value: '',
            apiEnv: 'km',
            explica: { mensagem: 'Informe a quilometragem do veículo.' },
            onChange: this.veiFormOnChangeValue
          },
          obs: {
            id: this.cpntHashId + '--obs',
            status: '',
            nome: 'Observação',
            mostrar: true,
            value: '',
            apiEnv: 'obs',
            onChange: this.veiFormOnChangeValue
          }
        },
        botoes: {
          cancelar: {
            status: '',
            id: this.cpntHashId + '-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.veiFormFechar(false) }
          },
          salvar: {
            status: '',
            id: this.cpntHashId + '-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.veiFormSalvar() }
          },
        }
      }
    },
    mounted: function () {
      // VERIFICA SE TEM OS USUARIOS DA LICENÇA DE USO
      if ([ '', null, undefined ].indexOf(this.$store.state.flagBuscaVei) !== -1) {
        // IMPORTA A FUNÇÃO
        const SESSAO_ATUALIZAR_VUEX = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_VUEX

        // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS NA API
        SESSAO_ATUALIZAR_VUEX('sinesp', () => { this.veiFormIniciar() })
      } else {
        this.veiFormIniciar()
      }
    },
    methods: {
      veiFormIniciar: function () {        
        // VERIFICA SE ESTÁ EDITANDO ALGUM REGISTRO
        if (this.cpntId >= 1) {
          // SETA O STATUS DA PAGINA
          this.veiFormSetaStatusGeral('carregando')

          // BUSCA OS DADOS PARA O FORMULARIO
          this.veiFormBuscaDados(this.cpntId, (retorno) => {
            // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
            var chaves = Object.keys(this.campos)

            // RODA O VETOR DOS CAMPOS
            for (var indexC in chaves) {
              // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
              var chave = chaves[indexC]

              // SETA OS VALORES DO CAMPO
              this.veiFormSetarValorCampo(chave, retorno)

              // SETA O VALOR INICIAL DO CAMPO
              this.campos[chave].valueIni = this.campos[chave].value
            }

            // CHAMA A FUNÇÃO PARA FINALIZAR O CARREGAMENTO
            this.veiFormFinalizarCarregamento()

            // VERIFICA SE DEVE ATUALIZAR O CADASTRO DA PLACA
            if ([ '', null, undefined ].indexOf(retorno.ref_modelo) !== -1 && this.$store.state.flagBuscaVei === true) {
              // SETA A VARIAVEL QUE ESTÁ SENDO ATUALIZADO A PLACA
              this.atualizando = true
              
              // FAZ A BUSCA DA PLACA
              this.veiFormBuscarCadastroApi(true)
            }
          })
        } else {
          // SETA O ID DO CONTATO RECEBIDO
          if ([ '', null, undefined ].indexOf(this.$route.params.id_con_nome) === -1 && [ '', null, undefined ].indexOf(this.$route.params.id_con) === -1) {
            this.campos.id_con.value = { id: this.$route.params.id_con, nome: this.$route.params.id_con_nome, empresa: '', cnpj_cpf: '' }
          }

          // SETA O NOME DIGITADO EM OUTRA TELA
          if ([ '', null, undefined ].indexOf(this.cpntNomeDig) === -1 && this.cpntNomeDig.length === 7) {
            // SETA O NOME DA PLACA RECEBIDA
            this.campos.placa.value = this.cpntNomeDig

            // FAZ A BUSCA AUTOMATICA DOS DADOS
            if (this.$store.state.flagBuscaVei === true) {
              this.veiFormBuscarCadastroApi(true)
            }
          }

          // CHAMA A FUNÇÃO PARA FINALIZAR O CARREGAMENTO
          this.veiFormFinalizarCarregamento()

          // VERIFICA O CAMPO QUE DEVE REALIZAR O FOCUS
          if ([ '', null, undefined ].indexOf(this.campos.id_con.value) !== -1 || Object.keys(this.campos.id_con.value).length === 0) {
            this.veiFormRealizarFocusCampo('id_con')
          } else {
            this.veiFormRealizarFocusCampo('placa')
          }
        }
      },
      veiFormFinalizarCarregamento: function () {
        // VERIFICA O QUE DEVE FAZER COM CADA CAMPO
        this.campos.buscar.disabled = this.$store.state.flagBuscaVei !== true
        this.campos.id_mar.newOption = this.$store.state.flagBuscaVei === false
        // this.campos.id_mod.disabled = this.$store.state.flagBuscaVei !== true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TELA
        this.veiFormSetaStatusGeral('')
      },
      veiFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiFormRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.veiFormRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      veiFormBuscaDados: function (id, callback) {
        // SETA O QUERY GET NA API
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          id: null,
          id_con: { j: { nome: null, cnpj_cpf: null, empresa: null, pessoa: null, status: null} }, 
          placa: null,
          id_mod: { j: { nome: null } },
          ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } },
          id_mar: { j: { nome: null } },
          ano: null,
          cor: null,
          motor: null,
          combus: null,
          km: null,
          obs: null,
          status: null,
          updated_user: { j: { usuario: null } },
          updated_at: null
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/veiculo/get', 'POST', queryGet, function (retorno) {
          callback(retorno.data[0])
        }, this.veiFormSetaStatusGeral)
      },
      veiFormSetarValorCampo: function (chave, dados) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var options = null

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'id_con':
            value = { id: dados.id_con, nome: dados.id_con_nome, empresa: dados.id_con_empresa, cnpj_cpf: dados.id_con_cnpj_cpf, status: dados.id_con_status }
            break

          case 'id_mar':
            value = [ '', null, undefined ].indexOf(dados.ref_modelo) !== -1 ? { id: dados.id_mar, nome: dados.id_mar_nome } : { id: dados.ref_modelo_id_marca, nome: dados.ref_modelo_id_marca_j_marca }
            break

          case 'id_mod':
            value = [ '', null, undefined ].indexOf(dados.ref_modelo) !== -1 ? { id: dados.id_mod, nome: dados.id_mod_nome } : { id: dados.ref_modelo, nome: dados.ref_modelo_j_modelo }
            break

          case 'placa':
          case 'motor':
          case 'cor':
          case 'combus':
          case 'km':
          case 'obs':
          case 'ano':
            value = [ '', null, undefined ].indexOf(dados[chave]) === -1 ? dados[chave] : ''
            break
        }

        // PEGA OS OPTIONS DO CAMPO
        if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
          options = this.campos[chave].options
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options !== null && options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }
        
        // VERIFICA SE TE DEVE ATUALIZAR O CMAPO
        if (chave === 'id_mod' && this.$store.state.flagBuscaVei === true) {
          // PEGA A MARCA DO VEICULO
          var id_mar = typeof this.campos.id_mar.value === "string" ? this.campos.id_mar.value : this.campos.id_mar.value.id

          // VERIFICA SE DEVE HABILITAR OU NÃO O CAMPO
          this.$set(this.campos[chave], 'disabled', id_mar === '')
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)

        // VERIFICA SE TEM VALOR PARA ATUALIZAR
        if (options !== null) {
          this.$set(this.campos[chave], 'options', options)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiFormOnNovoContato: function (value) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: 'contato', id: 0, nome: value }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar, id, dados) => {
            if (atualizar === true) {
              // CONVERTE AS CHAVES RECEBIDAS
              for (var indexD in dados) {
                dados['id_con_' + indexD] = dados[indexD]
              }
              
              // SETA OS DADOS DO CONTATO NO FORMULARIO
              this.veiFormOnChangeValue(dados, this.campos.id_con.id)
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      veiFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'class', '')

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'id_mar':
            if (this.$store.state.flagBuscaVei === true) {
              // SETA O NOVO VALOR NO MODELO
              this.campos.id_mod.value = ''

              // SETA O NOVO VALOR NO MODELO
              this.campos.id_mod.disabled = (value === '' || value.id === '')

              // SETA O NOVO VALOR NO MODELO
              this.campos.id_mod.options = []
            }
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiFormBuscarMarca: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA A VARIAVEL
          var router = ''

          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // VERIFICA QUAL ROTA DEVE CHAMAR
          switch (this.$store.state.flagBuscaVei) {
            case true:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/referencia/vei-marca/get/'

              // SETA OS CAMPOS QUE DEVE RETORNAR
              queryGet.field = { id: null, j_marca: { a: 'nome' } }

              // // SETA O NOVO VALOR NO MODELO
              // this.campos.id_mod.value = ''

              // // SETA O NOVO VALOR NO MODELO
              // this.campos.id_mod.disabled = true

              // // SETA O NOVO VALOR NO MODELO
              // this.campos.id_mod.options = []
              break

            case false:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/veiculo/marca/get/'

              // SETA OS CAMPOS QUE DEVE RETORNAR
              queryGet.field = { id: null, nome: null }
              break
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.veiFormBuscarMarca(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_mar.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.id_mar, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      veiFormBuscarModelo: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // INICIA A VARIAVEL
          var router = ''

          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // VERIFICA QUAL ROTA DEVE CHAMAR
          switch (this.$store.state.flagBuscaVei) {
            case true:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/referencia/vei-modelo/get/'

              // SETA OS CAMPOS QUE DEVE RETORNAR
              queryGet.field = { id: null, j_modelo: { a: 'nome' } }

              // SETA WHERE DA MARCA SELECIONADA
              queryGet.where = { f: 'id_marca', o: '=', v: typeof this.campos.id_mar.value === "string" ? this.campos.id_mar.value : this.campos.id_mar.value.id }
              break

            case false:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/veiculo/modelo/get/'

              // SETA OS CAMPOS QUE DEVE RETORNAR
              queryGet.field = { id: null, nome: null }
              break
          }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI(router, 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.veiFormBuscarModelo(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_mod.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.id_mod, 'options', registros)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      veiFormSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.botoes.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          this.veiFormSalvarMarca(formData, (formData) => {
            this.veiFormSalvarModelo(formData, (formData) => {
              // INICIA A VARIAVEL
              var method = 'POST'
        
              // VERIFICA QUAL ROTA DEVE CHAMAR
              if (this.$store.state.flagBuscaVei === true) {
                // SETA O CAMPO
                formData.ref_modelo = formData.id_mod
    
                // DELETA AS OUTRAS INFORMAÇÕES
                delete formData.id_mod
                delete formData.id_mar
              }
    
              // VERIFICA SE TEM AGUM REGISTRO PARA ATUALIZAR
              if (typeof this.cpntId === 'object' || this.cpntId !== 0) {
                // SETA O ID QUE DEVE ATUALIZAR
                formData.j_id = '[' + (typeof this.cpntId === 'object' ? this.cpntId.join(',') : this.cpntId) + ']'
    
                // SETA QUE SERÁ UMA ATUALIZAÇÃO
                method = 'PUT'
              }
    
              // COMUNICA COM A API
              this.$store.state.comunicaAPI('/veiculo', method, formData, (retorno) => {
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno)
                
                // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
                this.veiFormFechar(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
              }, this.veiFormSetaStatusGeral, (apiValid, apiStatus) => { this.veiFormTratarValidacao(apiValid, apiStatus, finalizacao) })
            })
          })
        })
      },
      veiFormTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // VERIFICA SE O CAMPO EXISTE, SE EXISTE CONVERTE
        if ([ '', null, undefined ].indexOf(apiValid.ref_modelo) === -1) {
          // SETA OS DADOS DO MODELO
          apiValid.id_mod = apiValid.ref_modelo

          // REMOVE A CHAVE PARA NÃO APRESENTAR DUAS VEZES
          delete apiValid.ref_modelo
        }

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      veiFormSalvarMarca: function (_formData, callback) {
        if (_formData.id_mar !== '__NOVO_OPTION__') {
          callback(_formData)
        } else {
          // PEGA O VALOR DIGITADO PELO CLIENTE
          var option = this.campos.id_mar.value

          // INICIA AS VARIAVEIS
          var formData = { nome: option._text }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/veiculo/marca', 'POST', formData, (retorno) => {
            // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
            this.campos.id_mar.options = []
            this.campos.id_mar.value = { id: retorno.ref.id, nome: option._text }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // SETA O ID ATUALIZADO DO MODELO
            _formData.id_mar = retorno.ref.id

            // FINALIZA O PROCESSO E RETORNA A FUNÇÃO
            callback(_formData)
          }, this.veiFormSetaStatusGeral, this.veiFormTratarValidacao)
        }
      },
      veiFormSalvarModelo: function (_formData, callback) {
        if (_formData.id_mod !== '__NOVO_OPTION__') {
          callback(_formData)
        } else {
          // PEGA O VALOR DIGITADO PELO CLIENTE
          var option = this.campos.id_mod.value

          // INICIA AS VARIAVEIS
          var formData = {}
          var router = ''

          // VERIFICA A AÇÃO QUE DEVE REALIZAR
          switch (this.$store.state.flagSinesp + '_' + this.$store.state.flagBuscaVei) {
            // LIBERA INSERIR MODELO COM O SINESP ATIVADO, CONFORME SOLICITADO PELO RAPHAEL, APÓS CONVERSA COM O JULIANO DA FRESSATO CLU 1996
            case 'true_true':
            case 'false_true':
              formData = { id_marca: (this.campos.id_mar.value === "string" ? this.campos.id_mar.value : this.campos.id_mar.value.id), modelo: option._text }
              router = '/referencia/vei-modelo'
              break

            default:
              formData = { nome: option._text }
              router = '/veiculo/modelo'
              break
          }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI(router, 'POST', formData, (retorno) => {
            // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
            this.campos.id_mod.options = []
            this.campos.id_mod.value = { id: retorno.ref.id, nome: option.nome }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // SETA O ID ATUALIZADO DO MODELO
            _formData.id_mod = retorno.ref.id

            // FINALIZA O PROCESSO E RETORNA A FUNÇÃO
            callback(_formData)
          }, this.veiFormSetaStatusGeral, this.veiFormTratarValidacao)
        }
      },
      veiFormFechar: function (atualizar = false, id = null, dados = null) {
        if (atualizar === true && id !== null && dados === null) {
          this.veiFormBuscaDados(id, (retorno) => { this.veiFormFechar(atualizar, id, retorno) })
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)

          // VERIFICA SE DEVE MUDAR A ROTA DO VUE
          if (this.$route.name === 'veiculo_form') {
            this.$router.push({ name: 'veiculo_gere', params: {} })
          }
        }
      },
      veiFormBuscarMontarValorBusca: function (chave, tipo, dados = {}) {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = ''

        // VERIFICA O VALOR QUE DEVE RETORNAR
        switch (chave + '_' + tipo) {
          case 'placa_atual':
            valor = this.campos.placa.value
            break
          case 'placa_novo':
            valor = dados.placa
            break

          case 'id_mar_atual':
            valor = this.campos.id_mar.value.nome
            break
          case 'id_mar_novo':
            valor = dados.id_marca_nome
            break

          case 'id_mod_atual':
            valor = typeof this.campos.id_mod.value === "string" ? this.campos.id_mod.value : this.campos.id_mod.value.nome
            break
          case 'id_mod_novo':
            valor = dados.id_modelo_nome
            break

          case 'cor_atual':
            valor = this.campos.cor.value
            break
          case 'cor_novo':
            valor = dados.cor
            break

          case 'ano_atual':
            valor = this.campos.ano.value
            break
          case 'ano_novo':
            valor = (dados.ano.length === 4 ? dados.ano.substring(2, 4) : dados.ano) + '/' + (dados.anoModelo.length === 4 ? dados.anoModelo.substring(2, 4) : dados.anoModelo)
            break

          case 'obs_atual':
            valor = this.campos.obs.value
            break
          case 'obs_novo':
            valor = 'Chassi Final: ' + dados.chassi
            break
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      veiFormBuscarSetarValorCampo: function (chave, valor, callback = null) {
        // SETA O VALOR RECEBIDO
        this.$set(this.campos[chave], 'value', valor)

        // SETA A CLASS DO CAMPO
        this.$set(this.campos[chave], 'class', 'rf-field-destaque-busca_api')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[chave], 'mensagem', '')

        // SETA O STATUS DO CAMPO
        this.$set(this.campos[chave], 'disabled', false)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      veiFormBuscarSetarValores: function (chave, acao, dados) {
        // INICIA A VARIAVEL QUE VAI SETAR O VALOR
        var valor = null

        // VERIFICA O VALOR QUE DEVE RETORNAR
        switch (chave + '_' + acao.id) {
          case 'id_mod_2':
            this.veiFormSetarMarcaBusca({ id: dados.id_marca, nome: dados.id_marca_nome }, () => { this.veiFormSetarModeloBusca({ id: dados.id_modelo, nome: dados.id_modelo_nome }) })
            break

          default:
            if (acao.id === '2') {
              valor = this.veiFormBuscarMontarValorBusca(chave, 'novo', dados)
            } else if (acao.id === '1') {
              valor = this.veiFormBuscarMontarValorBusca(chave, 'atual', dados) + ' ' + this.veiFormBuscarMontarValorBusca(chave, 'novo', dados)
            }
            break
        }

        // VERIFICA SE TEM VALOR PARA SER PREENCHIDO
        if (valor !== null) {
          this.veiFormBuscarSetarValorCampo(chave, valor)
        }
      },
      veiFormSetarMarcaBusca: function (id_marca, callback) {
        // PEGA O ID DA MARCA
        var marcaId = typeof this.campos.id_mar.value === "string" ? this.campos.id_mar.value : this.campos.id_mar.value.id

        // VERIFICA SE A MARCA É DIFERENTE DO QUE ESTÁ SELECIONADO
        if (id_marca !== marcaId) {
          this.veiFormBuscarMarca(() => { this.veiFormBuscarSetarValorCampo('id_mar', id_marca, callback) })
        } else {
          this.veiFormBuscarSetarValorCampo('id_mar', id_marca, callback)
        }
      },
      veiFormSetarModeloBusca: function (id_modelo) {
        // PEGA O ID DA MARCA
        var modeloId = typeof this.campos.id_mod.value === "string" ? this.campos.id_mod.value : this.campos.id_mod.value.id

        // VERIFICA SE A MARCA É DIFERENTE DO QUE ESTÁ SELECIONADO
        if (id_modelo !== modeloId) {
          this.veiFormBuscarModelo(() => { this.veiFormBuscarSetarValorCampo('id_mod', id_modelo) })
        } else {
          this.veiFormBuscarSetarValorCampo('id_mod', id_modelo)
        }
      },
      veiFormBuscarCadastroApi: function (silencioso = false) {
        // SETA O STATUS DO BOTÃO
        this.campos.buscar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O MAPA DE ATUALIZAÇÕES
        var mapa = [
          {
            nome: 'Modelo',
            chave: 'id_mod',
            acoes: [ 'manter', 'substituir' ]
          },
          {
            nome: 'Cor',
            chave: 'cor',
            acoes: [ 'manter', 'substituir' ]
          },
          {
            nome: 'Ano',
            chave: 'ano',
            acoes: [ 'manter', 'substituir' ]
          },
          {
            nome: 'Observação',
            chave: 'obs',
            acoes: [ 'manter', 'mesclar', 'substituir' ]
          }
        ]

        // SETA A ROTA QUE DEVE BUSCAR
        var router = '/referencia/buscar/vei-placa/get/'

        // INICIA A VARIAVEL PARA RECEBER OS PARAMETROS
        var _params = {}

        // SETA A PLACA NA STRING
        var string = this.campos.placa.value

        // REMOVE OS TRAÇO E ESPAÇO DA STRING
        while (string.indexOf('-') > -1 || string.indexOf(' ') > -1) {
          string = string.replace('-', '')
          string = string.replace(' ', '')
        }

        // MONTA O VETOR DE DADOS
        _params[string] = null

        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'BUSCAR_CADASTRO_API', router: router, method: 'GET', params: _params, mapa: mapa, silencioso: silencioso, buscarValor: this.veiFormBuscarMontarValorBusca, buscaComplementar: this.veiFormBuscarModeloMarca, setarValor: this.veiFormBuscarSetarValores }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          if (silencioso === true) {
            this.atualizando = false
          }

          // SETA O STATUS DO BOTÃO
          this.campos.buscar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      veiFormBuscarModeloMarca: function (dados, callback) {
        // INICIA A ROTA QUE DEVE CHAMAR
        var router = '/referencia/vei-modelo/get/'

        // INICIA A QUERY
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA O NOME DOS CAMPOS
        queryGet.field = { id: { a: 'id_modelo' }, j_modelo: { a: 'id_modelo_nome' }, id_marca: { j: { j_marca: { a: 'id_marca_nome' } } } }

        // SETA O WHERE DO REQUEST
        queryGet.where = { f: 'id', o: '=', v: dados.id_modelo }

        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI(router, 'GET', queryGet, (retorno) => {
          // PEGA O VALOR RECEBIDO
          var vetor = retorno.data.length >= 1 ? retorno.data[0] : {}

          // JUNTA OS VALORES
          dados = Object.assign(dados, vetor)

          // RETORNA O VALOR NO CALLBACK RECEBIDO
          callback(dados)
        }, this.veiFormSetaStatusGeral)
      }
    },
    computed: {
      veiFormMostrarPlaca: function () {
        return typeof this.cpntId !== 'object' || this.cpntId.length === 1
      },
      veiFormTituloDialog: function () {
        // INICIA A VARIAVEL
        var valor = ''

        // SETA O NOME DO VEICULO
        valor += this.campos.placa.valueIni

        // SETA A MARCA DO VEICULO
        valor += ' - ' + this.campos.id_mar.valueIni.nome

        // SETA A MODELO DO VEICULO
        valor += ' - ' + this.campos.id_mod.valueIni.nome

        // RETORNA O VALOR MONTADO
        return valor
      } 
    }
  }
</script>
